// CreateDivisionModal.tsx
import React, { FC, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface CreateDivisionModalProps {
  show: boolean;
  handleClose: () => void;
  handleCreate: (enterpriseId: string, name: string) => Promise<void>;
  enterpriseId: string;
}

const CreateDivisionModal: FC<CreateDivisionModalProps> = ({
  show,
  handleClose,
  handleCreate,
  enterpriseId
}) => {
  const { t } = useTranslation();
  const [name, setName] = useState("");

  const handleSubmit = () => {
    handleCreate(enterpriseId, name);
    setName("");
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton className="bg-primary">
        <Modal.Title className="text-white">{t("create_division")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="divisionName">
            <Form.Label>{t("division_name")}</Form.Label>
            <Form.Control
              type="text"
              placeholder={t("enter_division_name") || ""}
              value={name}
              onChange={e => setName(e.target.value)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer className="justify-content-between">
        <Button variant="secondary" onClick={handleClose}>
          {t("close")}
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          {t("create")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CreateDivisionModal;


/* // src/components/CreateDivisionModal.js
import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

function CreateDivisionModal({ show, handleClose, handleCreate, enterpriseId }) {
  const { t } = useTranslation();
  const [name, setName] = useState('');

  const handleSubmit = () => {
    handleCreate(enterpriseId, name);
    setName('');
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton className="bg-primary">
        <Modal.Title className="text-white">{t('create_division')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="divisionName">
            <Form.Label>{t('division_name')}</Form.Label>
            <Form.Control
              type="text"
              placeholder={t('enter_division_name')}
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer className="justify-content-between">
        <Button variant="secondary" onClick={handleClose}>
          {t('close')}
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          {t('create')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default CreateDivisionModal;
 */